import { render, staticRenderFns } from "./SafeForWorkSetup.vue?vue&type=template&id=6bb65b71&"
import script from "./SafeForWorkSetup.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports